import React, {useEffect, useState, useContext, useRef, useCallback} from 'react'
import axios from 'axios';
import Cookies from 'js-cookie';
import { AuthContext } from '../helpers/AuthContex';
import {Modal , Button, Input, Select,Table,Space,Form,Radio,InputNumber,Pagination,DatePicker} from 'antd'
import { useParams } from 'react-router-dom';
import { DownloadOutlined, PrinterOutlined } from '@ant-design/icons';
import { defaultLayoutPlugin } from '@react-pdf-viewer/default-layout';
import '@react-pdf-viewer/default-layout/lib/styles/index.css';
import MyDocument from '../pages/pdf';
import { pdf } from '@react-pdf/renderer';
import BillSummaryDocument from '../pages/pdf_billsumary';
import BillSummaryMonthDocument from '../pages/pdf_billsumary_month';
import {css} from '@emotion/css'
import { SearchOutlined } from '@ant-design/icons';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import {useNavigate} from 'react-router-dom'

import dayjs from 'dayjs';
const utc = require("dayjs/plugin/utc");
const timezone = require("dayjs/plugin/timezone");

dayjs.extend(utc);
dayjs.extend(timezone);

// const bangkokTimezone = "Asia/Bangkok" // Unused, keeping for potential future use

function formatDate(inputDate) {
  const date = new Date(inputDate);
  const day = date.getDate();
  const months = [
      "มกราคม", "กุมภาพันธ์", "มีนาคม", "เมษายน",
      "พฤษภาคม", "มิถุนายน", "กรกฎาคม", "สิงหาคม",
      "กันยายน", "ตุลาคม", "พฤศจิกายน", "ธันวาคม"
  ];
  const month = months[date.getMonth()];
  const year = date.getFullYear() + 543;
  const hour = date.getHours();
  const minute = date.getMinutes();
  const formattedHour = (hour < 10 ? '0' : '') + hour;
  const formattedMinute = (minute < 10 ? '0' : '') + minute;
  const formattedDate = `${day} ${month} ${year} ${formattedHour}:${formattedMinute}`;
  return formattedDate;
}


const Billlist = () => {
    const Navigator = useNavigate();
    const {id} = useParams()
    const [bill, setBill] = useState([])
    const [billItem, setBillitem] = useState([])
    const [order, setOrders] = useState([])
    const [service, setServices] = useState([])
    const [courseItem, setCourseItem] = useState([])
    const [billshow , setBillshow] = useState([])
    const [billItemshow, setBillitemshow] = useState([])
    const [billdata ,setBilldata] = useState([])
    const [patient_data, setPatient_data] = useState({})
    const {authState} = useContext(AuthContext)
    const sortOption = [{value:1 ,label:"ทั้งหมด"},{value:2 ,label:"เรียงตามวันที่ มาก > น้อย"},{value:3 ,label:"เรียงตามวันที่ น้อย > มาก"},{value:6 ,label:"บิลวันนี้"},{value:7 ,label:"สรุปตามช่วงวันที่"},{value:8 ,label:"สรุปตามช่วงเดือน"}]
    const [selectedValue, setSelectedValue] = useState(1)
    const [isModalOpen, setIsModalopen] = useState(false)
    const [searchQuery, setSearchQuery] = useState('');
    const [filteredBill, setFilteredBill] = useState([]);
    const defaultLayoutPluginInstance = defaultLayoutPlugin();
    const [pdfDataUrl, setPdfDataUrl] = useState('');
    const [listOfDepartment, setListOfdepartment] = useState();
    const [isLoading, setLoading] = useState(true);
    const [searchText, setSearchText] = useState('');
    const [searchedColumn, setSearchedColumn] = useState('');
    const searchInput = useRef(null);
    const [departmentLabel,setDepartmentLabel]= useState('')
    
    // Pagination states
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [totalCount, setTotalCount] = useState(0);
    const [totalPages, setTotalPages] = useState(0);
    const [hasNextPage, setHasNextPage] = useState(false);
    const [hasPrevPage, setHasPrevPage] = useState(false);
    const [globalSearch, setGlobalSearch] = useState('');
    const [dateSearch, setDateSearch] = useState(null);
    const [summaryData, setSummaryData] = useState([]);
    const [viewMode, setViewMode] = useState('normal'); // 'normal', 'daily', 'monthly'
    
    // Summary pagination states
    const [summaryCurrentPage, setSummaryCurrentPage] = useState(1);
    const [summaryPageSize, setSummaryPageSize] = useState(10);
    const [summaryTotalCount, setSummaryTotalCount] = useState(0);
    const [summaryTotalPages, setSummaryTotalPages] = useState(0);
    const [summaryHasNextPage, setSummaryHasNextPage] = useState(false);
    const [summaryHasPrevPage, setSummaryHasPrevPage] = useState(false);
    
    // Lazy loading state for monthly details
    const [monthlyDetails, setMonthlyDetails] = useState({});
    const [loadingMonthlyDetails, setLoadingMonthlyDetails] = useState({});
    
    // Cache for bill items - stores bill items by bill ID
    const [billItemsCache, setBillItemsCache] = useState({});
    const [loadingBillItems, setLoadingBillItems] = useState({});

    const [isPaymentEditModalOpen, setIsPaymentEditModalCancle] = useState(false);
    const [isExporting, setIsExporting] = useState(false);
    const [isPdfModalOpen, setIsPdfModalOpen] = useState(false);

    // Column search filters state
    const [columnFilters, setColumnFilters] = useState({});
    

    const [form] = Form.useForm();

    function convertDateFormat(originalDateStr) {
      const originalDate = new Date(originalDateStr);
      const year = originalDate.getFullYear();
      const month = String(originalDate.getMonth() + 1).padStart(2, '0');
      const day = String(originalDate.getDate()).padStart(2, '0');
      const formattedDate = `${day}/${month}/${year}`;
      return formattedDate;
    }

    const handleModalCancle = () =>
    {
      setIsModalopen(false)
    }

    const handleModalOpen = async (record,billdata,bill_type,department) =>
    {
      setIsModalopen(true);

        const response =  await axios.get(process.env.REACT_APP_API_URL + `/patient/byId/${record.patient_id}`,{ headers:{accessToken: Cookies.get('accessToken'),}})
            setPatient_data(response.data)

        try {
         
          const blob = await pdf(
            <MyDocument order={billdata} patient_data={response.data} type={2} date={formatDate(record.createdAt)} billid={record.id} service={service} courseItem={courseItem} department={department} additional_discount={record.additional_discount} remark={record.remark}/>
        ).toBlob({ quality: 1 });

        
          
          const url = URL.createObjectURL(blob);
          setPdfDataUrl(url.toString())
        } catch (error) {
          console.error('Error generating PDF:', error);
        }

    }



    const handlePaymentEditModalCancle = () =>
    {
      setIsPaymentEditModalCancle(false);
      form.resetFields();
    }

    const handlePaymentEditModalOpen = (record) =>
    {
      setIsPaymentEditModalCancle(true)
      form.setFieldValue('payment_method', record.payment_method);
      form.setFieldValue('id', record.id);
    }

    const handlePaymetnEditFinish = async()=>
    {
      setLoading(true)
      const data = form.getFieldsValue();
      await axios.put(process.env.REACT_APP_API_URL + '/course/bills/payment-method-edit' ,data ,{ headers:{accessToken: Cookies.get('accessToken'),}})
      await fetchdata(currentPage, pageSize, globalSearch);
      handlePaymentEditModalCancle();
    }


    // Handle PDF modal open - show PDF preview like in product.js
    const handlePdfModalOpen = async () => {
      setIsExporting(true);
      setIsPdfModalOpen(true);

      try {
        let exportType = 'normal';
        let filter = '';
        let sortOrder = 'DESC';

        // Determine export type and parameters based on selectedValue
        if (selectedValue === 7) {
          exportType = 'daily';
        } else if (selectedValue === 8) {
          exportType = 'monthly';
        } else {
          exportType = 'normal';
          if (selectedValue === 6) {
            filter = 'today';
          }
          if (selectedValue === 2) {
            sortOrder = 'DESC'; // newest first
          } else if (selectedValue === 3) {
            sortOrder = 'ASC';  // oldest first
          }
        }

        const exportParams = new URLSearchParams({
          selectedValue: selectedValue.toString(),
          search: globalSearch,
          department_id: authState.department_id.toString(),
          sortOrder: sortOrder,
          filter: filter,
          exportType: exportType,
          dateFilter: dateSearch ? dateSearch.format('YYYY-MM-DD') : ''
        });

        const response = await axios.get(
          process.env.REACT_APP_API_URL + `/course/export-bills?${exportParams}`,
          { headers: { accessToken: Cookies.get('accessToken') } }
        );

        const exportData = response.data;

        if (exportType === 'normal') {
          // For normal export, show message that PDF export is not available for detailed bills
          alert('การส่งออก PDF สำหรับรายการบิลแบบละเอียดยังไม่พร้อมใช้งาน กรุณาเลือกสรุปตามวันที่หรือเดือน');
          setIsPdfModalOpen(false);
          return;
        } else if (exportType === 'daily' || exportType === 'monthly') {
          // Transform data for PDF format
          const pdfData = exportData.summaryData.map(summary => ({
            [exportType === 'daily' ? 'date' : 'monthYear']: summary.period,
            amount: summary.total_count,
            cash: `${summary.cash_count} (${summary.cash_amount.toLocaleString()})`,
            mobile_banking: `${summary.transfer_count} (${summary.transfer_amount.toLocaleString()})`,
            card: `${summary.card_count} (${summary.card_amount.toLocaleString()})`,
            noPay: `${summary.none_count} (${summary.none_amount.toLocaleString()})`,
            total_amount: summary.total_amount.toLocaleString()
          }));

          // Generate PDF based on export type
          const pdfDoc = exportType === 'daily'
            ? <BillSummaryDocument data={pdfData} d_label={departmentLabel} />
            : <BillSummaryMonthDocument data={pdfData} d_label={departmentLabel} />;

          const blob = await pdf(pdfDoc).toBlob();
          const url = URL.createObjectURL(blob);
          setPdfDataUrl(url.toString());
        }

      } catch (error) {
        console.error('Error generating PDF:', error);
        setIsPdfModalOpen(false);
      } finally {
        setIsExporting(false);
      }
    };

    const handlePdfModalCancel = () => {
      setIsPdfModalOpen(false);
      setPdfDataUrl('');
    };


    

    function transformData(data, item1, item2) {
      // Create maps for quick lookups
      const item1Map = new Map(item1.map(item => [parseInt(item.id), item]));
      const item2Map = new Map(item2.map(item => [item.service_id, item]));

      return data.map(billItem => {
          const matchingItem1 = item1Map.get(parseInt(billItem.order_id));
          const matchingItem2 = item2Map.get(matchingItem1.item_id);

          return {
              key: billItem.id,
              order_id: billItem.order_id,
              item_id: matchingItem1.item_id,
              item_amount: matchingItem1.item_times,
              type: matchingItem1.type,
              item_totalprice: matchingItem1.item_totalprice,
              price_to_paid: billItem.price_to_paid,
              billId: billItem.billId,
              discount_value: billItem.discount_value,
              remain_price: billItem.remain_price,
              employee_id: billItem.employee_id,
              times_used: billItem.times_used,
              inviter_id: matchingItem1.inviter_id,
              employee_list: billItem.employee_list,
              payment_method: matchingItem1.payment_method,
              handfee: billItem.handfee,
              item_name: matchingItem2.service_name,
              item_price: matchingItem2.service_price,
              commission_name: matchingItem1.inviter_id,
              commission: matchingItem1.comission_type
          };
      });
  }

    const handleTableSearch = (selectedKeys, confirm, dataIndex) => {
      confirm();
      setSearchText(selectedKeys[0]);
      setSearchedColumn(dataIndex);

      // Update column filters state
      const searchValue = selectedKeys[0];
      const newColumnFilters = {
        ...columnFilters,
        [dataIndex]: searchValue
      };
      setColumnFilters(newColumnFilters);

      // Reset to first page and fetch with updated column filters
      setCurrentPage(1);
      setSummaryCurrentPage(1);
      
      const dateString = dateSearch ? dateSearch.format('YYYY-MM-DD') : '';

      if (viewMode === 'normal') {
        if (selectedValue === 6) {
          // For today's bills
          fetchDataWithSort(1, pageSize, globalSearch, 'DESC', 'today', dateString, newColumnFilters);
        } else {
          // For other normal views
          let sortOrder = 'DESC';
          if (selectedValue === 2) {
            sortOrder = 'DESC';
          } else if (selectedValue === 3) {
            sortOrder = 'ASC';
          }
          fetchDataWithSort(1, pageSize, globalSearch, sortOrder, '', dateString, newColumnFilters);
        }
      } else {
        // For summary views
        const summaryType = selectedValue === 7 ? 'daily' : 'monthly';
        fetchSummaryData(summaryType, 1, summaryPageSize, globalSearch, dateString, newColumnFilters);
      }
    };
    const handleReset = (clearFilters, dataIndex) => {
      clearFilters();
      setSearchText('');
      
      // Remove this column's filter from columnFilters state
      const newColumnFilters = { ...columnFilters };
      delete newColumnFilters[dataIndex];
      setColumnFilters(newColumnFilters);

      // Refresh data with updated column filters
      setCurrentPage(1);
      setSummaryCurrentPage(1);
      
      const dateString = dateSearch ? dateSearch.format('YYYY-MM-DD') : '';

      if (viewMode === 'normal') {
        if (selectedValue === 6) {
          fetchDataWithSort(1, pageSize, globalSearch, 'DESC', 'today', dateString, newColumnFilters);
        } else {
          let sortOrder = 'DESC';
          if (selectedValue === 2) {
            sortOrder = 'DESC';
          } else if (selectedValue === 3) {
            sortOrder = 'ASC';
          }
          fetchDataWithSort(1, pageSize, globalSearch, sortOrder, '', dateString, newColumnFilters);
        }
      } else {
        const summaryType = selectedValue === 7 ? 'daily' : 'monthly';
        fetchSummaryData(summaryType, 1, summaryPageSize, globalSearch, dateString, newColumnFilters);
      }
    };
    const getColumnSearchProps = (dataIndex) => ({
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters, close }) => {
        // Pre-populate with existing column filter value
        const currentFilter = columnFilters[dataIndex] || '';
        if (selectedKeys.length === 0 && currentFilter) {
          setSelectedKeys([currentFilter]);
        }
        
        return (
          <div
            style={{
              padding: 8,
            }}
            onKeyDown={(e) => e.stopPropagation()}
          >
            <Input
              ref={searchInput}
              placeholder={`ค้าหา ${dataIndex}`}
              value={selectedKeys[0]}
              onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
              onPressEnter={() => handleTableSearch(selectedKeys, confirm, dataIndex)}
              style={{
                marginBottom: 8,
                display: 'block',
              }}
            />
            <Space>
              <Button
                onClick={() => handleTableSearch(selectedKeys, confirm, dataIndex)}
                icon={<SearchOutlined />}
                size="small"
                className='bg-[#7877FF]'
                style={{
                  width: 90,
                }}
                type="primary"
              >
                Search
                
              </Button>
              <Button
                onClick={() => clearFilters && handleReset(clearFilters, dataIndex)}
                size="small"
                style={{
                  width: 90,
                }}
              >
                Reset
              </Button>
    
            </Space>
          </div>
        );
      },
      filterIcon: (filtered) => (
        <SearchOutlined
          style={{
            color: (columnFilters[dataIndex] || filtered) ? '#1677ff' : undefined,
          }}
        />
      ),
      onFilter: (value, record) =>
        record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
      onFilterDropdownOpenChange: (visible) => {
        if (visible) {
          setTimeout(() => searchInput.current?.select(), 100);
        }
      },
      // Show current filter value if exists
      filteredValue: columnFilters[dataIndex] ? [columnFilters[dataIndex]] : null,
    });
    


    const handleSelect = (value) =>
    {
      // Prevent unnecessary API calls if the same value is selected
      if (selectedValue === value) {
        return;
      }

      setSelectedValue(value);
      setDateSearch(null); // Clear date search when switching view modes
      setColumnFilters({}); // Clear column filters when switching view modes

      // For pagination-enabled views, refresh data with appropriate sorting
      if (value === 1 || value === 2 || value === 3) {
        setViewMode('normal');
        let sortOrder = 'DESC';

        if (value === 2) {
          sortOrder = 'DESC'; // newest first
        } else if (value === 3) {
          sortOrder = 'ASC';  // oldest first
        } else if (value === 1) {
          sortOrder = 'ASC';  // default ascending
        }

        // Reset to first page and fetch with new sorting
        setCurrentPage(1);
        fetchDataWithSort(1, pageSize, globalSearch, sortOrder, '', '', {});
      }

      // For today's bills (6), fetch from API with filter
      if (value === 6) {
        setViewMode('normal');
        // Reset to first page and fetch today's bills
        setCurrentPage(1);
        fetchDataWithSort(1, pageSize, globalSearch, 'DESC', 'today', '', {});
      }

      // For daily summary (7)
      if (value === 7) {
        setViewMode('daily');
        setSummaryCurrentPage(1);
        setMonthlyDetails({}); // Clear monthly details cache
        setLoadingMonthlyDetails({});
        fetchSummaryData('daily', 1, summaryPageSize, globalSearch, '', {});
      }

      // For monthly summary (8)
      if (value === 8) {
        setViewMode('monthly');
        setSummaryCurrentPage(1);
        setMonthlyDetails({}); // Clear monthly details cache
        setLoadingMonthlyDetails({});
        fetchSummaryData('monthly', 1, summaryPageSize, globalSearch, '', {});
      }
    }

    // New function to fetch data with custom sorting
    const fetchDataWithSort = useCallback(async (page = 1, limit = pageSize, search = '', sortOrder = 'DESC', filter = '', dateFilter = '', columnSearch = {}) => {
      setLoading(true);

      try {
        const billsParams = new URLSearchParams({
          page: page.toString(),
          limit: limit.toString(),
          sortBy: 'createdAt',
          sortOrder: sortOrder,
          search: search,
          filter: filter,
          department_id: authState.department_id.toString(),
          dateFilter: dateFilter
        });

        // Add column-specific search parameters
        Object.keys(columnSearch).forEach(key => {
          if (columnSearch[key]) {
            billsParams.append(`column_${key}`, columnSearch[key]);
          }
        });

        const billsresponse = await axios.get(
          process.env.REACT_APP_API_URL + `/course/bill?${billsParams}`,
          { headers:{accessToken: Cookies.get('accessToken')} }
        );

        let paginatedBillsData = billsresponse.data;
        let filterbillsresponse = paginatedBillsData.bills || [];

        const newData = filterbillsresponse.map(item=> ({...item, key: item.id }))
        setBill(newData);
        setTotalCount(paginatedBillsData.totalCount || 0);
        setTotalPages(paginatedBillsData.totalPages || 0);
        setHasNextPage(paginatedBillsData.hasNextPage || false);
        setHasPrevPage(paginatedBillsData.hasPrevPage || false);

        // Get corresponding bill items for the current page bills
        const billItemParams = new URLSearchParams({
          page: page.toString(),
          limit: limit.toString(),
          sortBy: 'createdAt',
          sortOrder: sortOrder,
          search: search
        });

        const billitemresponse = await axios.get(
          process.env.REACT_APP_API_URL + `/course/bills/billitem/byId/${authState.department_id}?${billItemParams}`,
          { headers:{accessToken: Cookies.get('accessToken')} }
        );

        const billItemData = billitemresponse.data;
        setBillitem(billItemData.billItems || []);

        const list_of_orders = await axios.get(process.env.REACT_APP_API_URL + `/course/patientorder`,{ headers:{accessToken: Cookies.get('accessToken'),}})
        setOrders(list_of_orders.data)

        const services = await axios.get(process.env.REACT_APP_API_URL + `/course/service`,{ headers:{accessToken: Cookies.get('accessToken'),}})
        setServices(services.data)

        const coruseItem = await axios.get(process.env.REACT_APP_API_URL + `/course/courseItem`,{ headers:{accessToken: Cookies.get('accessToken'),}})
        setCourseItem(coruseItem.data)

        const department = await axios.get(process.env.REACT_APP_API_URL + `/patient/clinic`, { headers:{accessToken: Cookies.get('accessToken'),},})
        setListOfdepartment(department.data)

        setDepartmentLabel(department.data.find((item) => item.id === authState.department_id)?.department || 'ทั้งหมด')

        // Transform and set bill item data for expandable rows
        const newData2 = transformData(billItemData.billItems || [], list_of_orders.data, services.data)
        setBillitemshow(newData2)

      } catch (error) {
        console.error('Error fetching sorted data:', error);
      } finally {
        setLoading(false);
      }
    }, [authState.department_id, pageSize])

    // Function to fetch summary data for daily/monthly views
    const fetchSummaryData = useCallback(async (type, page = summaryCurrentPage, limit = summaryPageSize, search = '', dateFilter = '', columnSearch = {}) => {
      setLoading(true);
      try {
        const summaryParams = new URLSearchParams({
          type: type,
          search: search,
          department_id: authState.department_id,
          page: page.toString(),
          limit: limit.toString(),
          dateFilter: dateFilter
        });

        // Add column-specific search parameters
        Object.keys(columnSearch).forEach(key => {
          if (columnSearch[key]) {
            summaryParams.append(`column_${key}`, columnSearch[key]);
          }
        });

        const response = await axios.get(
          process.env.REACT_APP_API_URL + `/course/bill-summary?${summaryParams}`,
          { headers: { accessToken: Cookies.get('accessToken') } }
        );

        setSummaryData(response.data.summaryData || []);
        setSummaryTotalCount(response.data.totalCount || 0);
        setSummaryTotalPages(response.data.totalPages || 0);
        setSummaryHasNextPage(response.data.hasNextPage || false);
        setSummaryHasPrevPage(response.data.hasPrevPage || false);
      } catch (error) {
        console.error('Error fetching summary data:', error);
      } finally {
        setLoading(false);
      }
    }, [authState.department_id, summaryCurrentPage, summaryPageSize]);

    // Function to fetch monthly details (daily breakdown) on demand
    const fetchMonthlyDetails = useCallback(async (year, month) => {
      const monthKey = `${year}-${month}`;
      
      // Don't fetch if already loading or already loaded
      if (loadingMonthlyDetails[monthKey] || monthlyDetails[monthKey]) {
        return;
      }

      setLoadingMonthlyDetails(prev => ({ ...prev, [monthKey]: true }));

      try {
        const response = await axios.get(
          process.env.REACT_APP_API_URL + `/course/monthly-details/${year}/${month}?department_id=${authState.department_id}&search=${globalSearch}`,
          { headers: { accessToken: Cookies.get('accessToken') } }
        );

        setMonthlyDetails(prev => ({ 
          ...prev, 
          [monthKey]: response.data 
        }));
      } catch (error) {
        console.error('Error fetching monthly details:', error);
      } finally {
        setLoadingMonthlyDetails(prev => ({ ...prev, [monthKey]: false }));
      }
    }, [authState.department_id, globalSearch]);

    // Function to fetch bill items for specific bills on demand
    const fetchBillItemsForBill = useCallback(async (billId) => {
      // Don't fetch if already loading or already loaded
      if (loadingBillItems[billId] || billItemsCache[billId]) {
        return;
      }

      setLoadingBillItems(prev => ({ ...prev, [billId]: true }));

      try {
        // Fetch bill items for this specific bill using the new endpoint
        const response = await axios.get(
          process.env.REACT_APP_API_URL + `/course/billitem/bill/${billId}`,
          { headers: { accessToken: Cookies.get('accessToken') } }
        );

        // Also need to fetch the supporting data for transformation
        const [ordersResponse, servicesResponse] = await Promise.all([
          axios.get(process.env.REACT_APP_API_URL + `/course/patientorder`, { headers: { accessToken: Cookies.get('accessToken') } }),
          axios.get(process.env.REACT_APP_API_URL + `/course/service`, { headers: { accessToken: Cookies.get('accessToken') } })
        ]);

        // Transform the bill items
        const transformedBillItems = transformData(response.data || [], ordersResponse.data, servicesResponse.data);

        // Cache the result
        setBillItemsCache(prev => ({ 
          ...prev, 
          [billId]: transformedBillItems 
        }));

      } catch (error) {
        console.error('Error fetching bill items for bill:', billId, error);
      } finally {
        setLoadingBillItems(prev => ({ ...prev, [billId]: false }));
      }
    }, []);

    const fetchdata = async (page = currentPage, limit = pageSize, search = globalSearch, dateFilter = '')=> {
      setLoading(true);

      try {
        // Get paginated bills data
        const billsParams = new URLSearchParams({
          page: page.toString(),
          limit: limit.toString(),
          sortBy: 'createdAt',
          sortOrder: 'DESC',
          search: search,
          department_id: authState.department_id.toString(),
          dateFilter: dateFilter
        });

        const billsresponse = await axios.get(
          process.env.REACT_APP_API_URL + `/course/bill?${billsParams}`,
          { headers:{accessToken: Cookies.get('accessToken')} }
        );

        let paginatedBillsData = billsresponse.data;
        let filterbillsresponse = paginatedBillsData.bills || [];

        const newDataBills = filterbillsresponse.map(item=> ({...item, key: item.id }))
        setBill(newDataBills);
        setTotalCount(paginatedBillsData.totalCount || 0);
        setTotalPages(paginatedBillsData.totalPages || 0);
        setHasNextPage(paginatedBillsData.hasNextPage || false);
        setHasPrevPage(paginatedBillsData.hasPrevPage || false);

        // Get corresponding bill items for the current page
        const billItemParams = new URLSearchParams({
          page: page.toString(),
          limit: limit.toString(),
          sortBy: 'createdAt',
          sortOrder: 'DESC',
          search: search
        });

        const billitemresponse = await axios.get(
          process.env.REACT_APP_API_URL + `/course/bills/billitem/byId/${authState.department_id}?${billItemParams}`,
          { headers:{accessToken: Cookies.get('accessToken')} }
        );

        const billItemData = billitemresponse.data;
        setBillitem(billItemData.billItems || []);


        const list_of_orders = await axios.get(process.env.REACT_APP_API_URL + `/course/patientorder`,{ headers:{accessToken: Cookies.get('accessToken'),}})
        setOrders(list_of_orders.data)

        const services = await axios.get(process.env.REACT_APP_API_URL + `/course/service`,{ headers:{accessToken: Cookies.get('accessToken'),}})
        setServices(services.data)

        const coruseItem = await axios.get(process.env.REACT_APP_API_URL + `/course/courseItem`,{ headers:{accessToken: Cookies.get('accessToken'),}})
        setCourseItem(coruseItem.data)

        const department = await axios.get(process.env.REACT_APP_API_URL + `/patient/clinic`, { headers:{accessToken: Cookies.get('accessToken'),},})
        setListOfdepartment(department.data)

        setDepartmentLabel(department.data.find((item) => item.id === authState.department_id)?.department || 'ทั้งหมด')

        // Remove client-side filtering for today's bills since it's now handled by API
        const newData2 = transformData(billItemData.billItems || [], list_of_orders.data, services.data)
        setBillitemshow(newData2)


      } catch (error) {
        console.error('Error fetching data:', error);
      } finally {
        setLoading(false);
      }
    }


    // Pagination handlers
    const handlePageChange = (page, size) => {
      setCurrentPage(page);
      setPageSize(size);

      const dateString = dateSearch ? dateSearch.format('YYYY-MM-DD') : '';

      if (selectedValue === 6) {
        // For today's bills, use fetchDataWithSort with 'today' filter
        fetchDataWithSort(page, size, globalSearch, 'DESC', 'today', dateString, columnFilters);
      } else {
        // For other filters, use regular fetchdata but with enhanced params
        let sortOrder = 'DESC';
        if (selectedValue === 2) {
          sortOrder = 'DESC';
        } else if (selectedValue === 3) {
          sortOrder = 'ASC';
        }
        fetchDataWithSort(page, size, globalSearch, sortOrder, '', dateString, columnFilters);
      }
    };

    // Summary pagination handler
    const handleSummaryPageChange = (page, size) => {
      setSummaryCurrentPage(page);
      setSummaryPageSize(size);

      const dateString = dateSearch ? dateSearch.format('YYYY-MM-DD') : '';

      if (selectedValue === 7) {
        // For daily summary
        fetchSummaryData('daily', page, size, globalSearch, dateString, columnFilters);
      } else if (selectedValue === 8) {
        // For monthly summary
        fetchSummaryData('monthly', page, size, globalSearch, dateString, columnFilters);
      }
    };

    const handleDateSearch = (date) => {
      setCurrentPage(1); // Reset to first page when searching
      setSummaryCurrentPage(1); // Reset summary page when searching
      setMonthlyDetails({}); // Clear monthly details cache when searching
      setLoadingMonthlyDetails({});

      const dateString = date ? date.format('YYYY-MM-DD') : '';

      if (selectedValue === 6) {
        // For today's bills, use fetchDataWithSort with 'today' filter
        fetchDataWithSort(1, pageSize, globalSearch, 'DESC', 'today', dateString, columnFilters);
      } else if (selectedValue === 7) {
        // For daily summary
        fetchSummaryData('daily', 1, summaryPageSize, globalSearch, dateString, columnFilters);
      } else if (selectedValue === 8) {
        // For monthly summary
        fetchSummaryData('monthly', 1, summaryPageSize, globalSearch, dateString, columnFilters);
      } else {
        // For other filters, use fetchDataWithSort with proper sort order
        let sortOrder = 'DESC';
        if (selectedValue === 2) {
          sortOrder = 'DESC';
        } else if (selectedValue === 3) {
          sortOrder = 'ASC';
        }
        fetchDataWithSort(1, pageSize, globalSearch, sortOrder, '', dateString, columnFilters);
      }
    };

    const handleSearch = (value) => {
      setGlobalSearch(value);
      setCurrentPage(1); // Reset to first page when searching
      setSummaryCurrentPage(1); // Reset summary page when searching
      setMonthlyDetails({}); // Clear monthly details cache when searching
      setLoadingMonthlyDetails({});

      const dateString = dateSearch ? dateSearch.format('YYYY-MM-DD') : '';

      if (selectedValue === 6) {
        // For today's bills, use fetchDataWithSort with 'today' filter
        fetchDataWithSort(1, pageSize, value, 'DESC', 'today', dateString, columnFilters);
      } else if (selectedValue === 7) {
        // For daily summary
        fetchSummaryData('daily', 1, summaryPageSize, value, dateString, columnFilters);
      } else if (selectedValue === 8) {
        // For monthly summary
        fetchSummaryData('monthly', 1, summaryPageSize, value, dateString, columnFilters);
      } else {
        // For other filters, use fetchDataWithSort with proper sort order
        let sortOrder = 'DESC';
        if (selectedValue === 2) {
          sortOrder = 'DESC';
        } else if (selectedValue === 3) {
          sortOrder = 'ASC';
        }
        fetchDataWithSort(1, pageSize, value, sortOrder, '', dateString, columnFilters);
      }
    };

    const handleSearchChange = (e) => {
      const value = e.target.value;
      setGlobalSearch(value);
      if (value === '') {
        setCurrentPage(1);
        setSummaryCurrentPage(1);
        setMonthlyDetails({}); // Clear monthly details cache
        setLoadingMonthlyDetails({});
        const dateString = dateSearch ? dateSearch.format('YYYY-MM-DD') : '';
        if (selectedValue === 6) {
          // For today's bills, use fetchDataWithSort with 'today' filter
          fetchDataWithSort(1, pageSize, '', 'DESC', 'today', dateString, columnFilters);
        } else if (selectedValue === 7) {
          // For daily summary
          fetchSummaryData('daily', 1, summaryPageSize, '', dateString, columnFilters);
        } else if (selectedValue === 8) {
          // For monthly summary
          fetchSummaryData('monthly', 1, summaryPageSize, '', dateString, columnFilters);
        } else {
          // For other filters, use fetchDataWithSort with proper sort order
          let sortOrder = 'DESC';
          if (selectedValue === 2) {
            sortOrder = 'DESC';
          } else if (selectedValue === 3) {
            sortOrder = 'ASC';
          }
          fetchDataWithSort(1, pageSize, '', sortOrder, '', dateString, columnFilters);
        }
      }
    };

    useEffect(() => {
      fetchdata();
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    // Debounced search effect
    useEffect(() => {
      const timeoutId = setTimeout(() => {
        if (globalSearch) {
          setCurrentPage(1);
          setSummaryCurrentPage(1);
          const dateString = dateSearch ? dateSearch.format('YYYY-MM-DD') : '';
          if (selectedValue === 6) {
            // For today's bills, use fetchDataWithSort with 'today' filter
            fetchDataWithSort(1, pageSize, globalSearch, 'DESC', 'today', dateString, columnFilters);
          } else if (selectedValue === 7) {
            // For daily summary
            fetchSummaryData('daily', 1, summaryPageSize, globalSearch, dateString, columnFilters);
          } else if (selectedValue === 8) {
            // For monthly summary
            fetchSummaryData('monthly', 1, summaryPageSize, globalSearch, dateString, columnFilters);
          } else {
            // For other filters, use fetchDataWithSort with proper sort order
            let sortOrder = 'DESC';
            if (selectedValue === 2) {
              sortOrder = 'DESC';
            } else if (selectedValue === 3) {
              sortOrder = 'ASC';
            }
            fetchDataWithSort(1, pageSize, globalSearch, sortOrder, '', dateString, columnFilters);
          }
        }
      }, 500);

      return () => clearTimeout(timeoutId);
    }, [globalSearch, dateSearch, pageSize, selectedValue, summaryPageSize, columnFilters, fetchSummaryData]); // eslint-disable-line react-hooks/exhaustive-deps


      // Summary table columns for daily/monthly view
      const summaryColumns = [
        {
          title: viewMode === 'daily' ? 'วันที่' : 'เดือน',
          dataIndex: 'period',
          key: 'period',
          width: '20%',
          ...getColumnSearchProps('period'),
        },
        {
          title: 'จำนวนรายการ',
          dataIndex: 'total_count',
          key: 'total_count',
          width: '10%',
          align: 'center',
        },
        {
          title: 'เงินสด',
          dataIndex: 'cash_count',
          key: 'cash_count',
          width: '10%',
          align: 'center',
          render: (text, record) => `${record.cash_count} (${record.cash_amount.toLocaleString()})`
        },
        {
          title: 'โอน',
          dataIndex: 'transfer_count',
          key: 'transfer_count',
          width: '10%',
          align: 'center',
          render: (text, record) => `${record.transfer_count} (${record.transfer_amount.toLocaleString()})`
        },
        {
          title: 'บัตรเครดิต/เดบิต',
          dataIndex: 'card_count',
          key: 'card_count',
          width: '15%',
          align: 'center',
          render: (text, record) => `${record.card_count} (${record.card_amount.toLocaleString()})`
        },
        {
          title: 'ไม่มี',
          dataIndex: 'none_count',
          key: 'none_count',
          width: '10%',
          align: 'center',
          render: (text, record) => `${record.none_count} (${record.none_amount.toLocaleString()})`
        },
        {
          title: 'จำนวนยอดขาย',
          dataIndex: 'total_amount',
          key: 'total_amount',
          width: '15%',
          align: 'center',
          render: (text) => parseFloat(text).toLocaleString(),
        },
      ];

      // Expandable row for summary table - handles both daily and monthly views
      const summaryExpandedRowRender = (record) => {
        // For daily view - show bills directly
        if (viewMode === 'daily') {
          const billColumns = [
            {
              title: 'Bill ID',
              dataIndex: 'id',
              key: 'id',
              width: '10%',
              ...getColumnSearchProps('id'),
            },
            {
              title: 'รหัสคนไข้',
              dataIndex: 'patient_id',
              key: 'patient_id',
              width: '10%',
              ...getColumnSearchProps('patient_id'),
              render: (patient_id) => (
                <button 
                  onClick={() => {Navigator(`/patient/${patient_id}/${authState.department_id}`)}} 
                  className='underline text-blue-900 bg-transparent border-none cursor-pointer p-0 m-0'
                >
                  {patient_id}
                </button>
              )
            },
            {
              title: 'ชื่อคนไข้',
              dataIndex: 'patient_name',
              key: 'patient_name',
              width: '30%',
              ...getColumnSearchProps('patient_name'),
            },
            {
              title: 'วันที่',
              dataIndex: 'createdAt',
              key: 'createdAt',
              width: '20%',
              render: (createdAt) => formatDate(createdAt)
            },
            {
              title: 'จำนวนเงิน',
              dataIndex: 'totoalvalue',
              key: 'totoalvalue',
              width: '15%',
              align: 'center',
              render: (text) => parseFloat(text).toLocaleString(),
            },
            {
              title: 'วิธีจ่ายเงิน',
              dataIndex: 'payment_method',
              key: 'payment_method',
              width: '15%',
              align: 'center',
              ...getColumnSearchProps('payment_method'),
            },
          ];

          return (
            <Table 
              columns={billColumns} 
              expandable={{
                expandedRowRender: expandedRowRender,
                defaultExpandedRowKeys: [],
              }}
              dataSource={record.bills.map(bill => ({...bill, key: bill.id}))} 
              pagination={false} 
              className={CollapsetableCSS}
              size="small"
            />
          );
        }

        // For monthly view - show daily breakdown
        if (viewMode === 'monthly') {
          const monthKey = `${record.year}-${record.month}`;
          const monthDetails = monthlyDetails[monthKey];
          const isLoading = loadingMonthlyDetails[monthKey];

          // Daily summary columns for nested view
          const dailyColumns = [
            {
              title: 'วันที่',
              dataIndex: 'date',
              key: 'date',
              width: '20%',
              ...getColumnSearchProps('date'),
            },
            {
              title: 'จำนวนรายการ',
              dataIndex: 'total_count',
              key: 'total_count',
              width: '10%',
              align: 'center',
            },
            {
              title: 'เงินสด',
              dataIndex: 'cash_count',
              key: 'cash_count',
              width: '10%',
              align: 'center',
              render: (text, record) => `${record.cash_count} (${record.cash_amount.toLocaleString()})`
            },
            {
              title: 'โอน',
              dataIndex: 'transfer_count',
              key: 'transfer_count',
              width: '10%',
              align: 'center',
              render: (text, record) => `${record.transfer_count} (${record.transfer_amount.toLocaleString()})`
            },
            {
              title: 'บัตรเครดิต/เดบิต',
              dataIndex: 'card_count',
              key: 'card_count',
              width: '15%',
              align: 'center',
              render: (text, record) => `${record.card_count} (${record.card_amount.toLocaleString()})`
            },
            {
              title: 'ไม่มี',
              dataIndex: 'none_count',
              key: 'none_count',
              width: '10%',
              align: 'center',
              render: (text, record) => `${record.none_count} (${record.none_amount.toLocaleString()})`
            },
            {
              title: 'จำนวนยอดขาย',
              dataIndex: 'total_amount',
              key: 'total_amount',
              width: '15%',
              align: 'center',
              render: (text) => parseFloat(text).toLocaleString(),
            },
          ];

          // Expandable row for daily summary - shows actual bills
          const dailyExpandedRowRender = (dailyRecord) => {
            const billColumns = [
              {
                title: 'Bill ID',
                dataIndex: 'id',
                key: 'id',
                width: '10%',
                ...getColumnSearchProps('id'),
              },
              {
                title: 'รหัสคนไข้',
                dataIndex: 'patient_id',
                key: 'patient_id',
                width: '10%',
                ...getColumnSearchProps('patient_id'),
                render: (patient_id) => (
                  <button 
                    onClick={() => {Navigator(`/patient/${patient_id}/${authState.department_id}`)}} 
                    className='underline text-blue-900 bg-transparent border-none cursor-pointer p-0 m-0'
                  >
                    {patient_id}
                  </button>
                )
              },
              {
                title: 'ชื่อคนไข้',
                dataIndex: 'patient_name',
                key: 'patient_name',
                width: '30%',
                ...getColumnSearchProps('patient_name'),
              },
              {
                title: 'วันที่',
                dataIndex: 'createdAt',
                key: 'createdAt',
                width: '20%',
                render: (createdAt) => formatDate(createdAt)
              },
              {
                title: 'จำนวนเงิน',
                dataIndex: 'totoalvalue',
                key: 'totoalvalue',
                width: '15%',
                align: 'center',
                render: (text) => parseFloat(text).toLocaleString(),
              },
              {
                title: 'วิธีจ่ายเงิน',
                dataIndex: 'payment_method',
                key: 'payment_method',
                width: '15%',
                align: 'center',
                ...getColumnSearchProps('payment_method'),
              },
            ];

            return (
              <Table 
                columns={billColumns} 
                expandable={{
                  expandedRowRender: expandedRowRender,
                  defaultExpandedRowKeys: [],
                }}
                dataSource={dailyRecord.bills.map(bill => ({...bill, key: bill.id}))} 
                pagination={false} 
                className={CollapsetableCSS}
                size="small"
              />
            );
          };

          if (isLoading) {
            return <div className="text-center p-4">กำลังโหลด...</div>;
          }

          if (!monthDetails) {
            return <div className="text-center p-4">ไม่มีข้อมูล</div>;
          }

          return (
            <Table
              columns={dailyColumns}
              expandable={{
                expandedRowRender: dailyExpandedRowRender,
                defaultExpandedRowKeys: [],
              }}
              dataSource={monthDetails.map((item, index) => ({...item, key: index}))}
              pagination={false}
              className={CollapsetableCSS}
              size="small"
            />
          );
        }
      };

      const expandedRowRender = (record) => {
        // First check if we have cached bill items for this specific bill
        const cachedBillItems = billItemsCache[record.key] || [];
        
        // If we don't have cached items, try to use the normal billItemshow data
        const billItemShowItems = billItemshow.filter((item) => item.billId === record.key);
        
        // Use cached items if available, otherwise use billItemshow data
        const filteredBillItems = cachedBillItems.length > 0 ? cachedBillItems : billItemShowItems;
        
        // If we don't have any bill items and aren't loading, trigger a fetch
        if (filteredBillItems.length === 0 && !loadingBillItems[record.key]) {
          fetchBillItemsForBill(record.key);
        }
        const ordercolumn = [
            {
              title: 'Order Id',
              dataIndex: 'order_id',
              key:'order_id'
            },
            {
                title: 'ชื่อ',
                dataIndex: 'item_name',
                key:'item_name'
            },
            {
                title: 'จำนวนครั้ง',
                dataIndex: 'item_amount',
                key:'item_amount',
            },
            {
                title: 'ราคาต่อหน่วย',
                dataIndex: 'item_price',
                key:'item_price'
            },
            {
              title: 'ราคารวม',
              dataIndex: 'item_totalprice',
              key:'item_totalprice'
            },
            {
              title: 'ราคาจ่าย',
              dataIndex: 'price_to_paid',
              key:'price_to_paid'
            },
            {
              title: 'รหัสผู้ทำการรักษา',
              dataIndex: 'employee_list',
              key: 'employee_list',
              width: '10%',
              render(_, record, index) {
                if (record.employee_list?.length === 0 ) {
                  return <span>ไม่มี</span>;
                }
                return record.employee_list?.map((employee, employeeIndex) => (
                  <span key={employeeIndex}>
                    {employee === 0  ? "-" : employee === -1 ? "-" : employee}
                    {employeeIndex !== record.employee_list.length - 1 && ','}
                  </span>
                ));
              }
            },
            {
              title: 'จำนวนค่ามือ',
              dataIndex: 'handfee',
              key: 'handfee',
              width: '10%',
              render(_, record, index) {
                if (record.employee_list?.length === 0 ) {
                  return <span>ไม่มี</span>;
                }
                return record.employee_list?.map((employee, employeeIndex) => (
                  <span key={employeeIndex}>
                    {employee === 0  ? "-" : employee === -1 ? "-" : record.handfee}
                    {employeeIndex !== record.employee_list.length - 1 && ','}
                  </span>
                ));
              }
            },
            {
              title: 'รหัสผู้เชิญ',
              dataIndex: 'commission_name',
              key: 'commission_name',
              width: '10%',
              render(commission_name) {
                return (
                  <span >
                    {commission_name === 0  ? "-" : commission_name === -1 ? "-" : commission_name}
                  </span>
                );
              }
            },
            {
              title: 'เปอเเปอร์เซ็นต์',
              dataIndex: 'commission',
              key: 'commission',
              width: '10%',
              render(commission) {
                return (
                    `${commission} %`
                );
              }
            },
            {
              title: 'ประเภท',
              dataIndex: 'type',
              key:'type',
              render: (type) => {
                if (type === 1) {
                  return <span>บริการ</span>;
                } else if (type === 2) {
                  return <span>คอร์สต์</span>;
                }
                return null;
              },
            },
          ]

        // Show loading state if we're fetching bill items
        if (loadingBillItems[record.key]) {
          return <div style={{ padding: '16px', textAlign: 'center', color: '#666' }}>
            กำลังโหลดข้อมูลรายการ...
          </div>;
        }

        // Show empty state if no bill items found after loading
        if (filteredBillItems.length === 0) {
          return <div style={{ padding: '16px', textAlign: 'center', color: '#666' }}>
            ไม่มีข้อมูลรายการในบิลนี้
          </div>;
        }

        return <Table columns={ordercolumn} dataSource={filteredBillItems} pagination={false} className={CollapsetableCSS}/>;
      };

      const generatePDF = async (record,billdata,bill_type, department) => {
        const response =  await axios.get(process.env.REACT_APP_API_URL + `/patient/byId/${record.patient_id}`,{ headers:{accessToken: Cookies.get('accessToken'),}})
            setPatient_data(response.data)
        try {
          const blob = await pdf(
                <MyDocument order={billdata} patient_data={response.data} type={2} date={formatDate(record.createdAt)} billid={record.id} service={service} courseItem={courseItem} department={department} additional_discount={record.additional_discount} remark={record.remark}/>
            ).toBlob({ quality: 1 });
          
          const url = URL.createObjectURL(blob);
          
          const a = document.createElement('a');
          a.href = url;
          a.download = `bill_${record.id}.pdf`; // Set the desired filename
          a.style.display = 'none';
          document.body.appendChild(a);
          a.click();
          
          // Remove the temporary anchor element
          document.body.removeChild(a);
          
          // Clean up the URL object
          URL.revokeObjectURL(url);
        } catch (error) {
          console.error('Error generating PDF:', error);
        }
      };



      const tableCSS = css({
        backgroundColor: 'white',
        '& table': {
          borderCollapse: 'collapse'
        },
        '& thead > tr': {
          borderWidth: '1px',
          borderColor: 'black',
          borderStyle: 'solid',
          backgroundColor: "blue"
        },
        '.ant-table-thead .ant-table-cell':
        {
          backgroundColor: '#00BA9E',
          color: 'white',
          borderRadius: 'unset !important'
        }
        
      });

      const CollapsetableCSS = css({
        backgroundColor: 'white',
        '& table': {
          borderCollapse: 'collapse'
        },
        '& thead > tr': {
          borderWidth: '1px',
          borderColor: 'grey',
          borderStyle: 'solid',
          backgroundColor: "blue"
        },
        '.ant-table-thead .ant-table-cell':
        {
          backgroundColor: 'grey',
          color: 'white',
          borderRadius: 'unset !important',
        },
        
      });





      const columns = [
        {
          title: 'Bill ID',
          dataIndex: 'id',
          key: 'id',
          width:'5%',
          ...getColumnSearchProps('id'),
        },
        {
          title: 'รหัสคนไข้',
          dataIndex: 'patient_id',
          key: 'patient_id',
          width:'5%',
          ...getColumnSearchProps('patient_id'),
          render : (patient_id) =>
            {
              return (
                <button
                  onClick={()=>{Navigator(`/patient/${patient_id}/${authState.department_id}`)}}
                  className='underline text-blue-900 bg-transparent border-none cursor-pointer p-0 m-0'
                >
                  {patient_id}
                </button>
              );
            }
        },
        {
          title: 'ชื่อคนไข้',
          dataIndex: 'patient_name',
          key: 'patient_name',
          width:'35%',
          ...getColumnSearchProps('patient_name'),
        },
        {
          title: 'Date',
          dataIndex: 'createdAt',
          key: 'createdAt',
          width:'15%',
          align:'center',
          render : (createdAt) =>
          {
            return formatDate(createdAt);
          }
        },
        {
          title: 'จำนวนเงินรวม',
          dataIndex: 'totoalvalue',
          key: 'totoalvalue',
          width:'5%',
          align:'center',
          render: (text) => parseFloat(text).toLocaleString(),
        },
        {
          title: 'วิธีจ่ายเงิน',
          dataIndex: 'payment_method',
          key: 'payment_method',
          width:'10%',
          align:'center',
          ...getColumnSearchProps('payment_method'),
          render : (_,record) =>
          {
            return(
              <div onClick={()=>{handlePaymentEditModalOpen(record)}} className='text-blue-400 hover:underline hover:cursor-pointer active:text-green-200 select-none duration-75 '>{record.payment_method}</div>
            )
          }
        },
        {
          title: 'ประเภทบิล',
          dataIndex: 'bill_type',
          key: 'bill_type',
          width:'5%',
          align:'center',
          render: (text, record) => {
            return record.bill_type === 1 ? 
            <div>บิลใหม่</div> : 
            <div>ตัดบิล</div>;
          }
        },  
        
        {
          title: 'จัดการ',
          key: 'operation',
          align:'center',
          width: '5%', 
          render: (text, record) => {
            const filteredBillItems = billItemshow.filter((item) => item.billId === record.id);
            const filterDepartment = listOfDepartment?.find((item) => item.id === parseInt(record.department_id))
            const billdata = filteredBillItems.map((item) => ({
              id: item.order_id,
              item_id: item.item_id,
              name: item.item_name,
              amount: item.item_amount,
              price: item.item_price,
              discount: item.discount_value,
              type: item.type,
              totalPrice: item.price_to_paid,
              remain: item.remain_price,
              employee_id: item.employee_id,
              times_used:item.times_used,
              inviter_id:item.inviter_id,
              employee_list: item.employee_list
              
            
          }));
            return(
              <div className='flex'>
              <Button icon={<DownloadOutlined />} onClick={()=>{generatePDF(record,billdata,record.bill_type ,filterDepartment)}}>โหลดPDF</Button>
              <Button icon={<DownloadOutlined />} onClick={()=>{handleModalOpen(record,billdata,record.bill_type ,filterDepartment)}}>เปิดดู PDF</Button>
              </div>
            )
          },
        },
      ];

      


    return (
      <>
        <div className='md:p-[24px]  md:bg-[#E77B7C] md:shadow-2xl md:mx-[10rem] mx-[0.5rem] rounded-xl mb-10' >
            <div className={`md:px-[24px] px-[0.5rem] pt-[24px] bg-white shadow-2xl rounded-xl ${(bill?.length === 0 ) ? 'pb-[24px]' : null}`}>

            {/* Search and Controls Section */}
            <div className='flex flex-col md:flex-row justify-between md:mx-10 mb-3 items-center gap-3'>
              <div className='flex items-center gap-3'>
                <span>เรียงตาม</span>
                <Select className='md:w-[10rem] w-[8rem]' options={sortOption} value={selectedValue} onSelect={handleSelect} />
                
                {/* Export PDF Button - only show for summary views */}
                {(selectedValue === 7 || selectedValue === 8) && (
                  <Button
                    icon={<PrinterOutlined />}
                    onClick={handlePdfModalOpen}
                    loading={isExporting}
                    className="bg-green-500 hover:bg-green-600 text-white border-green-500 hover:border-green-600"
                    type="primary"
                  >
                    {isExporting ? 'กำลังส่งออก...' : 'ส่งออก PDF'}
                  </Button>
                )}
              </div>

              {/* Global Search Input */}
              <div className='flex items-center gap-3'>
                <Input
                  placeholder="ค้นหาตามชื่อ รหัสคนไข้ หรือ Bill ID"
                  value={globalSearch}
                  onChange={handleSearchChange}
                  onPressEnter={() => handleSearch(globalSearch)}
                  style={{ width: 300 }}
                  suffix={<SearchOutlined />}
                />
                <DatePicker
                  placeholder="ค้นหาตามวันที่"
                  value={dateSearch}
                  onChange={(date) => {
                    setDateSearch(date);
                    handleDateSearch(date);
                  }}
                  format="DD/MM/YYYY"
                  allowClear={{
                    clearIcon: <span style={{ color: '#666', fontSize: '12px' }}>✕</span>
                  }}
                  style={{ width: 150 }}
                />
                {dateSearch && (
                  <Button
                    size="small"
                    onClick={() => {
                      setDateSearch(null);
                      handleDateSearch(null);
                    }}
                    style={{ marginLeft: 5 }}
                  >
                    ล้างวันที่
                  </Button>
                )}
              </div>

            </div>

            {viewMode === 'normal' ? (
              <>
            <Table
              columns={columns}
              expandable={{
                expandedRowRender: expandedRowRender,
                defaultExpandedRowKeys: ['id'],
              }}
              dataSource={bill}
              size={"small"}
              className={tableCSS}
              scroll={{x:'max-content'}}
              pagination={false} // Disable built-in pagination
              loading={isLoading}
            />
            
            {/* Custom Pagination Component */}
            <div className='flex justify-center mt-4 pb-4'>
              <Pagination
                current={currentPage}
                total={totalCount}
                pageSize={pageSize}
                onChange={handlePageChange}
                onShowSizeChange={handlePageChange}
                showSizeChanger
                showQuickJumper
                showTotal={(total, range) =>
                  `${range[0]}-${range[1]} ของ ${total} รายการ`
                }
                pageSizeOptions={['10', '20', '50', '100']}
              />
            </div>
              </>
            ) : (
              <>
                <Table
                  columns={summaryColumns}
                  expandable={{
                    expandedRowRender: summaryExpandedRowRender,
                    defaultExpandedRowKeys: [],
                    onExpand: (expanded, record) => {
                      // Lazy load monthly details when expanding a monthly summary row
                      if (expanded && viewMode === 'monthly' && record.year && record.month) {
                        fetchMonthlyDetails(record.year, record.month);
                      }
                    },
                  }}
                  dataSource={summaryData.map((item, index) => ({...item, key: index}))}
                  size={"small"}
                  className={tableCSS}
                  scroll={{x:'max-content'}}
                  pagination={false}
                  loading={isLoading}
                />
                
                {/* Summary Pagination Component */}
                <div className='flex justify-center mt-4 mb-4 pb-4'>
                  <Pagination
                    current={summaryCurrentPage}
                    total={summaryTotalCount}
                    pageSize={summaryPageSize}
                    onChange={handleSummaryPageChange}
                    onShowSizeChange={handleSummaryPageChange}
                    showSizeChanger
                    showQuickJumper
                    showTotal={(total, range) =>
                      `${range[0]}-${range[1]} ของ ${total} ${viewMode === 'daily' ? 'วัน' : 'เดือน'}`
                    }
                    pageSizeOptions={['10', '20', '50', '100']}
                  />
                </div>
              </>
            )}
          </div>
        </div>
  
        <Modal width={1000} title="ออกบิล" open={isModalOpen} onCancel={handleModalCancle} footer={[<Button key="ok" >ตกลง</Button>,<Button key="close" onClick={handleModalCancle} >ปิด</Button>]}>

          <embed src={pdfDataUrl} frameBorder={"0"} width={"100%"} height={window.innerWidth < 786 ? "500px" : "1000px"}/>
  
            
        </Modal>

        <Modal  title="แก้ไข้วิธีชำระเงิน" open={isPaymentEditModalOpen} onCancel={handlePaymentEditModalCancle} footer={false}>

            <Form form={form} onFinish={handlePaymetnEditFinish}>
            <Form.Item  style={{ marginBottom: "10px" }}
                      label="รหัสใบเสร็จ"
                      name="id"
                      rules={[
                        {
                          required: true,
                          message: 'กรุณาใส่รหัสบิล',
                        },
                      ]}
                    >
                    <InputNumber readOnly={true}></InputNumber>

                    </Form.Item>
                      <Form.Item  style={{ marginBottom: "10px" }}
                      label="วิธีการชำระเงิน"
                      name="payment_method"
                      rules={[
                        {
                          required: true,
                          message: 'กรุณาเลือกประเภท',
                        },
                      ]}
                    >
                      <Radio.Group>
                        <Radio value="เงินสด"> เงินสด </Radio>
                        <Radio value="โอนธนาคาร"> โอนธนาคาร </Radio>
                        <Radio value="บัตรเครดิต/เดบิต"> บัตรเครดิต/เดบิต </Radio>
                        <Radio value="ไม่มี"> ไม่มี</Radio>
                      </Radio.Group>
                    </Form.Item>
                    <Form.Item style={{marginBottom:'0px',display:'flex',justifyContent:'center'}}
                    >
              <Button htmlType="submit" >
                ตกลง
              </Button>
              <Button onClick={handlePaymentEditModalCancle} >
                ยกเลิก
              </Button>
            </Form.Item>
            </Form>
        </Modal>

        <Modal width={1000} title="สรุปยอดบิล" open={isPdfModalOpen} onCancel={handlePdfModalCancel} footer={[<Button key="ok" >ตกลง</Button>,<Button key="close" onClick={handlePdfModalCancel} >ปิด</Button>]}>
          <embed src={pdfDataUrl} frameBorder={"0"} width={"100%"} height={window.innerWidth < 786 ? "500px" : "1000px"}/>
        </Modal>

      </>
    );
}

export default Billlist